export const PACKAGE_FORM_SUBMIT_TYPE_SAVE = "save"
export const PACKAGE_FORM_SUBMIT_TYPE_SEND = "send"